'use strict';
var parent = require('../../stable/object/freeze');

module.exports = parent;
